import React, { Component } from 'react';
import { Dimmer } from "tabler-react";

export default class CallbackPage extends Component {
  render() {
    return (
      <Dimmer active></Dimmer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/callback/callback.react.js